import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { stripHtmlToText } from "../../helpers";
import { getRiskTitleByColor } from "../../helpers/managementSummary";
import { EntityRecordsTable, SectionTitle } from "../../shared";

const RISK_COLUMNS = [
    { key: "riskId", label: "Risk ID", width: "10%" },
    { key: "title", label: "Title", width: "30%" },
    { key: "category", label: "Category", width: "16%" },
    { key: "residualRisk", label: "Residual Risk", width: "14%" },
    { key: "owner", label: "Risk Owner", width: "18%" },
    { key: "status", label: "Status", width: "12%" },
];

const RiskAssessmentSection = ({ supplierData = {}, meta }) => {
    const risks = Array.isArray(supplierData?.risks) ? supplierData.risks : [];

    const records = risks.map((risk, index) => ({
        id: risk?.id || `risk-${index}`,
        riskId: `R${risk?.secondary_id || "-"}`,
        title: stripHtmlToText(risk?.description, "-"),
        category: risk?.category?.name,
        residualRisk: risk?.result_color ? getRiskTitleByColor(risk.result_color) : null,
        owner: risk?.owner_name,
        status: risk?.is_deleted ? "Deleted" : "Active",
    }));

    return (
        <View style={styles.wordSectionContent}>
            <EntityRecordsTable columns={RISK_COLUMNS} records={records} leading={(
                <SectionTitle
                    title={meta?.title || "Risk Assessment"}
                    number={meta?.number}
                    anchorId={meta?.anchorId}
                />
            )} />
        </View>
    );
};

export default withNamespaces()(RiskAssessmentSection);
